module.exports = __webpack_public_path__ + "static/media/up_2.307e4106.svg";